import { calendarModel } from 'APP/model/model';
import Entities from 'STORE';
import { User } from 'STORE/Users/User/User';

const SEARCH_RESULTS_LIMIT = 15;

export interface ISearchResult {
  users: User[];
  cursor?: string;
}

export async function searchUsersAddToCalendarEvent(
  searchValue: string,
  cursor?: string
): Promise<ISearchResult> {
  try {
    const data = await calendarModel.searchUsersAddToCalendarEvent({
      query: searchValue,
      limit: SEARCH_RESULTS_LIMIT,
      cursor,
      emails: [],
    });

    const usersMap = data.users
      .map((user) => new User(Entities.usersStore, user))
      .filter((user) => {
        return !user.isMe;
      });

    return {
      users: usersMap,
      cursor: data.cursor,
    };
  } catch {
    return {
      users: [],
      cursor: '',
    };
  }
}
